<template>
    <div class="app-main__inner">
        <TituloComponente icono-titulo="fas fa-clipboard-list" texto-titulo="Cargos" :to-create-action="{name:'NuevoCargo'}" to-create-text="Nuevo Cargo"/>
        <div class="tab-content">
            <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="main-card mb-3 card">
                            <div class="card-body">
                                <h5 class="card-title">Listado de Cargos</h5>
                                 <DataList ref="datatable" url="/cargos" :fields="fields" :rowClick="mostrarOpciones"></DataList>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>                               
    </div>  
</template>
<script>
    import TituloComponente from '@/components/layouts/TituloComponente';
    import DataList from '@/components/layouts/DataList';
    import axios from 'axios';
    import Swal from "sweetalert2";
    export default {
        name: "ListarCargos",
        components: {
            TituloComponente,
            DataList,
        },
        data(){
        return{
            cargo: [],
            fields: [
                {
                name: "codigo",
                label: "",
                type: "title",
                class: "",
                append: '-'
                },
                {
                name: "descripcion",
                label: "",
                type: "title",
                class: ""
                },
            ],
        }
        },
        created(){
        },
        mounted(){

        },
        methods:{
            mostrarOpciones(cargo) {
                console.log(cargo);
                Swal.fire({
                    title: cargo.descripcion,
                    showCancelButton: true,
                    confirmButtonText: "Editar",
                    cancelButtonText: "Eliminar",
                    confirmButtonColor: "#f7b924",
                    cancelButtonColor: "#d33",
                    reverseButtons: true
                }).then(result => {
                    if (result.value) {
                    this.$router.push({name:'EditarCargo', params:{id:cargo.id}})
                    } else if (
                    /* Read more about handling dismissals below */
                    result.dismiss === Swal.DismissReason.cancel
                    ) {
                    this.eliminarCargo(cargo)
                    }
                });
            },        
            eliminarCargo(cargo) {
            Swal.fire({
                title: "¿Estás seguro?",
                text: `¿Deseas eliminar ${cargo.descripcion} de manera permanente?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Eliminar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                this.loading = true;
                axios
                    .delete("cargos/" + cargo.id)
                    .then(res => {
                    Swal.fire(
                        "Eliminado",
                        `${res.data.cargo.descripcion} se ha eliminado con éxito.`,
                        "success"
                    );
                    console.log(this.$refs);
                    this.$refs.datatable.update();
                    })
                    .catch(err => console.log(err))
                    .finally(() => (this.loading = false));
                }
            });
            }
        },
    }
</script>